module.exports = __webpack_public_path__ + "static/media/video_thumb1.db96fe71.png";